import { useCallback, useState } from 'react';
/**
 * hook for callback and state of the focus
 *
 * @documented
 * @category Field
 * @import import useFieldFocus from '@gef-ui/form-core/hooks/field/useFieldFocus'
 * @returns {Object} result
 * @returns {function} result.hasFocus
 * @returns {function} result.setFocusFalse
 * @returns {function} result.setFocusTrue
 * @example
 *
 * 	const { hasFocus, setFocusFalse, setFocusTrue } = useFieldFocus();
 *
 */ const useFieldFocus = ()=>{
    const [hasFocus, setFocus] = useState(false);
    const setFocusFalse = useCallback(()=>setFocus(false), []);
    const setFocusTrue = useCallback(()=>setFocus(true), []);
    return {
        hasFocus,
        setFocusFalse,
        setFocusTrue
    };
};
export default useFieldFocus;
